import moment from 'moment';
import NavLink from 'next/link';
import {useContext} from 'react';

import PencilIcon from '@/public/icons/pencil.svg';
import PencilIconWhite from '@/public/icons/pencilWhite.svg';
import DeleteIcon from '@/public/icons/trash-red.svg';
import {DATE_FORMAT, SERVER_FORMAT} from '@/src/app/constants/date';
import {useTheme} from '@/src/hooks/useTheme';
import EmptyDataWithLink from '@/src/jobPortal/clinicPositions/components/EmptyDataWithLink';
import RouteContext from '@/src/routes/utils/RouteContext';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Text} from '@/src/ui';

import css from '../styles/ActiveJobPositionsLayout.module.css';

interface ActiveJobPositionsLayoutProps {
  data: Array<any>;
  onDeletePositionClick: Function;
  isLoading: boolean;
}

const ActiveJobPositionsLayout = ({
  data,
  onDeletePositionClick,
  isLoading,
}: ActiveJobPositionsLayoutProps): JSX.Element => {
  // @ts-ignore
  const {JOB_PORTAL_MY_POSITION_EDIT, JOB_PORTAL_MY_POSITION_PREVIEW} =
    useContext(RouteContext);
  const {isDarkMode} = useTheme();

  if (!data.length && !isLoading) {
    return <EmptyDataWithLink />;
  }

  return (
    <div>
      <table className={css.tableWithAction}>
        {/*table header*/}
        <tr className={css.tableHeader}>
          <th>
            <TextLocal id={'tables.name'} />
          </th>
          <th>
            <TextLocal id={'tables.actions'} />
          </th>
        </tr>

        {data.map((position) => (
          <tr className={css.tableContent} key={position.id}>
            <td>
              <Text
                color={Text.COLOR.ORANGE}
                fontSize={Text.FONT_SIZE.SIZE_14}
                lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
              >
                <TextLocal id={'job-portal.drafts'} />
              </Text>
              <NavLink
                href={JOB_PORTAL_MY_POSITION_PREVIEW.getLink(position.id)}
              >
                <a>
                  <Text
                    color={Text.COLOR.GREY}
                    fontWeight={Text.FONT_WEIGHT.BOLD}
                    lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
                  >
                    {position.title}
                  </Text>
                </a>
              </NavLink>
              <Text
                fontWeight={Text.FONT_WEIGHT.THIN}
                fontSize={Text.FONT_SIZE.SIZE_14}
                color={Text.COLOR.GREY}
                lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
              >
                <TextLocal
                  id={'job-portal.last-updated-date-value'}
                  params={{
                    date: moment(position.updated_at, SERVER_FORMAT).format(
                      DATE_FORMAT
                    ),
                  }}
                />
              </Text>
            </td>

            <td>
              <div className={css.actionIcon}>
                <span>
                  <NavLink
                    href={JOB_PORTAL_MY_POSITION_EDIT.getLink(
                      position.id,
                      position.title
                    )}
                  >
                    <a>
                      {isDarkMode ? (
                        <PencilIconWhite width={16} height={16} />
                      ) : (
                        <PencilIcon />
                      )}
                    </a>
                  </NavLink>
                </span>
                <span
                  onClick={() =>
                    onDeletePositionClick(position.id, position.title)
                  }
                >
                  <DeleteIcon />
                </span>
              </div>
            </td>
          </tr>
        ))}
      </table>
    </div>
  );
};

export default ActiveJobPositionsLayout;
